module.exports = __webpack_public_path__ + "static/img/img01.cd4d311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market/freetarget/img01.png
// module id = XT7J
// module chunks = 1